import React, { useEffect } from 'react';

const Testimonials = ({ id }) => {
  useEffect(() => {
    if (!document.querySelector('script[src="https://static.elfsight.com/platform/platform.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://static.elfsight.com/platform/platform.js';
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);

  return (
    <section id={id} data-testid="testimonials-section" className="py-24 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-gold text-sm font-semibold uppercase tracking-widest mb-4">
            Reviews
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl text-white mb-4">
            What couples say about us
          </h2>
          <p className="text-white/60 text-lg">
            Real reviews from Google and Facebook. Nothing hidden.
          </p>
        </div>
        <div className="max-w-5xl mx-auto">
          <div className="elfsight-app-494dec14-e896-44c5-a686-1744bfc88d68" data-elfsight-app-lazy></div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
